<script>

import cloneDeep from 'lodash/cloneDeep'
import lazyLoadComponent from '@router/lazyload-component'
import formatDate from '@utils/format-date'
import BaseButtonDialog from '@components/BaseButtonDialog'
import pageMixin from '@src/mixins/pagination'
import { membreLevelValidityTime } from '@utils/memberLevel'
import { addDays, addMonths, addYears } from 'date-fns'
import { authComputed } from '@state/helpers'

const initData = () => {
  return {
    levelId: '',
    reason:'',
    startedAt: '',
    expiredAt: '',
  }
}

export default {
  components: {
    BaseButtonDialog
  },
  
  filters: {
    formatDate,
  },
  mixins: [pageMixin],
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      memberData: cloneDeep(this.value),
      dialogChangeMemberLevelVisible: false,
      submitData:  {
        memberId: this.value.id, 
        ...initData()
      },
      blockReason: '',
      // getNewDate: new Date(),
      memberLevelList: [],
      rulesList: {
        levelId: [
          { 
            required: true, 
            message: '請選擇方案' 
          },
        ],
        startedAt: [
          { 
            required: true, 
            message: '請選擇日期' 
          },
        ],
        // reason: [
        //   { 
        //     required: true, 
        //     message: '請輸入原因' 
        //   },
        // ]
        // expiredAt: [
        //   { 
        //     required: true, 
        //     message: '請選擇日期' 
        //   },
        // ]
      },
      isMemberLevelStoreLoading : false,
      tryingGetMemberLevelLog: false,
      pageSize: 15,
      dialogBlockVisible: false
    }
  },
  computed: {
    ...authComputed,
    default: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    /*************** 會員等級效期 ***************/
    validityTime() {
      const startedAt = this.memberData.level.startedAt
      const expiredAt = this.memberData.level.expiredAt
      return membreLevelValidityTime(startedAt, expiredAt)
    },
  },
  watch: {
    currentPage: {
      handler: 'onChangeCurrentPage',
    },
  },
  created() {
    this.tryToFetchMemberList()
  },
  mounted() {
    this.setPagination()
  },
  methods: {
    formatDate,
    changeMemberLevel() {
      this.dialogChangeMemberLevelVisible = true
    },
    async tryToFetchMemberList() {
      // if(!this.currentUserRoutes.includes('view-memberlevel')) return
      const { items } = await this.$store.dispatch('memberLevel/fetchList', { paginate: 0})
      this.memberLevelList = items
    },
    onChangeCurrentPage(val) { 
      this.tryToFetchMemberInfo(this.default.id, val)
    },
    tryToSearchFilter(val) {
      const currentMemberLevel = this.memberLevelList.filter((item) => {
        return item.id === val
      })[0]
      const expiredAt = (startedAt) => {
        switch(currentMemberLevel.periodType) {
          case 'lifelong':
            this.submitData.expiredAt = ''
            break;
          case 'day':
            this.submitData.expiredAt = addDays(startedAt,currentMemberLevel.period)
            break;
          case 'month':
            this.submitData.expiredAt = addMonths(startedAt,currentMemberLevel.period)
            break;
          case 'year':
            this.submitData.expiredAt = addYears(startedAt,currentMemberLevel.period)
            break;
          default:
            break; 
        }
      }
      if(!this.submitData.startedAt) {
        this.submitData.startedAt = new Date()
        expiredAt(this.submitData.startedAt)
      } else {
        expiredAt(this.submitData.startedAt)
      }
    },
    async onSubmit() {
      await this.$refs['form'].validate();
      // this.isMemberLevelStoreLoading = true
      this.$nextTick(() => {
        this.tryToFetchMemberLevelStore()
        .then(()=> {
          // this.tryToFetchMemberInfo(this.submitData.member_id)
          this.onCloseDialogChangeMemberLevel()
          this.$emit('update')
        }).catch(() => {

        }).finally(() => {
          // this.isMemberLevelStoreLoading = false
        })
      })
    },
    async tryToFetchMemberInfo(memberId, page = 1) {
      this.tryingGetMemberLevelLog = true
      await this.$store.dispatch('member/fetchSingle', { memberId, page })
      .then((response)=> {
        this.memberData = response
        this.currentPage = page
        this.setPagination()
      }).finally(() => {
        this.tryingGetMemberLevelLog = false
      })
    },
    async tryToFetchMemberLevelStore() {
      const data = {
        ...this.submitData,
        startedAt: formatDate(this.submitData.startedAt, 'dateDayTime'),
        expiredAt: this.submitData.expiredAt ? formatDate(this.submitData.expiredAt, 'dateDayTime') : ''
      }
      await this.$store.dispatch('memberLevel/memberStore', data).then(() => {
        this.tryToFetchMemberInfo(this.submitData.memberId)
        return true
      }).catch(() => {
        return false
      })
    },
    onCloseDialogChangeMemberLevel() {
      this.dialogChangeMemberLevelVisible = false
      this.submitData = {
        memberId: this.default.id, 
        ...initData()
      }
    },
    onChangeStartedAt() {
      if(!this.submitData.levelId) return false
      this.tryToSearchFilter(this.submitData.levelId)
    },
    setPagination() {
      this.$nextTick(() => {
        this.$refs.pagination && this.$refs.pagination.updateTotal (this.memberData.level.logs.pagination.total)
      })
    },
    onChangeExpiredAt(e) {
      if(this.submitData.startedAt) {
        const startedAtDateTime =  formatDate(this.submitData.startedAt, 'dayTime')
        const expiredAtDate = formatDate(this.submitData.expiredAt, 'date')
        this.submitData.expiredAt = new Date(`${expiredAtDate} ${startedAtDateTime}`)
      }
    },
    async tryToBlock(block) {
      const memberId = this.default.id
      const submitData = {
        block: block,
        blockReason: this.blockReason,
      }
      await this.$store.dispatch('member/memberBlock', 
      { memberId, 
        submitData 
      }).then((res) => {
        this.tryToFetchMemberInfo(this.default.id)
        this.onCloseDialogDialogBlock()
      }).catch(() => {
        return false
      })
    },
    onCloseDialogDialogBlock() {
      this.blockReason = ''
      this.dialogBlockVisible = false
    },
    async cancelBlock() {
      await this.$confirm(`確定要取消黑名單？`, '提醒', {
        confirmButtonText: '確定',
        // showCancelButton: false,
        type: 'warning',
        center: true,
      })
      this.tryToBlock(0)
    }
  },
}
</script>

<template>
  <div 
    v-loading="tryingGetMemberLevelLog"
    :class="$style.detailEditMemberLevel"
  >
    <BasePageHeader :class="$style.header" title="會籍資料">
      <template v-slot:right>
        <el-button 
          v-if="!memberData.block.isBlock" 
          class="is-round" 
          @click="dialogBlockVisible = true"
        >
          <span>列入黑名單</span>
        </el-button>
        <el-button 
          v-else 
          class="is-round"
          @click="cancelBlock"
        >
          <span>取消黑名單</span>
        </el-button>
        <el-button v-if="currentUserRoutes.includes('view-memberlevel')" class="is-round" type="primary" @click="dialogChangeMemberLevelVisible = true">
          <span>變更會員等級</span>
        </el-button>
      </template>
    </BasePageHeader>
    <div class="isStylePageContent">
      <div>
        <h4 class="form-block-title">會籍資料</h4>
        <ul class="list-unstyled detailEditMemberLevel__memberLevelMain">
          <li class="Jost"><span class="text-grey">會員等級：</span>{{ memberData.level.title }}</li>
          <li class="Jost"><span class="text-grey">效期時間：</span>{{ validityTime }}</li>
          <li class="Jost"><span class="text-grey">原因說明：</span>{{ memberData.level.reason || '無' }}</li>
        </ul>
      </div>
      <el-divider class="my-5"></el-divider>
      <div class="mb-3">
        <h4 class="form-block-title">黑名單資料</h4>
        <ul class="list-unstyled detailEditMemberLevel__memberLevelMain">
          <li class="Jost"><span class="text-grey">黑名單：</span>{{ memberData.block.isBlock ? '是' : '否' }}</li>
          <li v-if="memberData.block.isBlock" class="Jost"><span class="text-grey">列入黑名單時間：</span>{{ formatDate(memberData.block.startedAt, 'date') }}</li>
          <li v-if="memberData.block.isBlock" class="Jost"><span class="text-grey">原因說明：</span>{{ memberData.block.blockReason || '無' }}</li>
        </ul>
      </div>
      <div class="mt-5">
        <el-table
          element-loading-text="取得資訊中"
          :data="memberData.level.logs.items"
          :default-sort="{ prop: 'createdAt', order: 'descending' }"
        >
          <el-table-column v-slot="{ row }" label="日期" width="200" prop="createdAt" sortable>
            <div class="Jost" style="font-weight: 500">{{ row.createdAt | formatDate }}</div>
            <span>{{ row.createdAt | formatDate('HH:mm') }}</span>
          </el-table-column>
          <el-table-column v-slot="{ row }" label="原因">
            <div>{{row.reason}}</div>
          </el-table-column>
          <el-table-column v-slot="{ row }" label="會員等級" width="150">
            <div>{{row.toLevelTitle}}</div>
          </el-table-column>
        </el-table>
        <BasePagination ref="pagination" :current-page.sync="currentPage" :page-size.sync="pageSize" />
      </div>
    </div>
    <BaseButtonDialog 
      :only-dialog="true" 
      :title="'變更會員等級'" 
      :dialog-visible.sync="dialogChangeMemberLevelVisible" 
      width="550px"
      :destroy="true" 
      @closed="onCloseDialogChangeMemberLevel"
    >
      <el-form 
        ref="form" 
        :model="submitData" 
        label-position="top"
        :rules="rulesList"
      >
        <el-form-item prop="levelId" label="會員方案">
          <el-select
            v-model="submitData.levelId"
            value-key="id"
            placeholder="選擇會員等級"
            class="is-border"
            clearable
            @change="tryToSearchFilter"
          >
            <el-option
              v-for="(item, index) in memberLevelList"
              :key="`list-tag-${index}`"
              :label="item.title"
              :value="item.id"
            ></el-option>
        </el-select>
      </el-form-item>
        <el-form-item label="生效日期" prop="startedAt">
          <el-date-picker 
            v-model="submitData.startedAt" 
            type="date" 
            placeholder="選擇日期" 
            style="width: 100%;"
            format="yyyy/MM/dd"
            class="bg-white is-border"
            @change="onChangeStartedAt"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="截止日期" prop="expiredAt">
          <el-date-picker 
            v-model="submitData.expiredAt" 
            type="date" 
            placeholder="選擇日期" 
            style="width: 100%;"
            format="yyyy/MM/dd"
            class="bg-white is-border"
            @change="onChangeExpiredAt"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="原因說明"  prop="reason">
          <el-input v-model="submitData.reason" type="textarea" :autosize="{ minRows: 9 }" class="bg-white is-border is-round"></el-input>
        </el-form-item>
        <el-form-item size="large">
          <div>
            <el-button 
              :loading="isMemberLevelStoreLoading" 
              class="w-100 is-round" 
              type="primary"
              @click="onSubmit">
                送出儲存
              </el-button>
          </div>
          <div class="mt-4">
            <el-button 
              class="w-100 is-round" 
              @click="onCloseDialogChangeMemberLevel">
                取消
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </BaseButtonDialog>
    <BaseButtonDialog 
      :only-dialog="true" 
      :title="`請說明${!memberData.block.isBlock ? '列入' : '取消'}黑名單情況`" 
      :dialog-visible.sync="dialogBlockVisible" 
      width="550px"
      :destroy="true" 
      @closed="onCloseDialogDialogBlock"
    >
      <el-form 
        ref="formBlock" 
        label-position="top"
      >
        <el-form-item label="原因說明"  prop="blockreason">
          <el-input 
            v-model="blockReason" 
            type="textarea"
            class="bg-white is-border is-round"
            :autosize="{ minRows: 9 }"
          >
          </el-input>
        </el-form-item>
        <el-form-item size="large">
          <div>
            <el-button
              v-if="!memberData.block.isBlock" 
              :loading="isMemberLevelStoreLoading" 
              class="w-100 is-round" 
              type="primary"
              @click="tryToBlock(1)">
                加入黑名單
            </el-button>
            <el-button
              v-else
              :loading="isMemberLevelStoreLoading" 
              class="w-100 is-round" 
              type="primary"
              @click="tryToBlock(0)">
                取消黑名單
            </el-button>
          </div>
          <div class="mt-4">
            <el-button 
              class="w-100 is-round" 
              @click="onCloseDialogDialogBlock">
                取消
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </BaseButtonDialog>
  </div>
</template>
<style lang="scss" module>
.detailEditMemberLevel {
  :global {
    .detailEditMemberLevel {
      &__memberLevelMain {
        // border-bottom: 1px solid #E5E7EB;
        li {
          &:not(:last-child) {
            margin-bottom: 2rem;
          }
          .text-grey {
            color: $color-text-light;
          }
        }
      }
    }
  }
}
</style>
